import React, { useEffect, useState } from 'react'
import { Spin } from 'antd';
import questions from './questions.json'
import Sparkles from './Sparkles'
import JustText from './JustText'
import QuizComponent from './QuizComponent'
import { _initdata, _quizdata } from '../RecoilState';
import { useRecoilState } from 'recoil';

const StoryOfLife = () => {
    const [allquestions, setAllquestions] = useState({});
    const [imagesPreloaded, setImagesPreloaded] = useState(false);
    const [initdata, setInitdata] = useRecoilState(_initdata);
    const [quizdata, setQuizdata] = useRecoilState(_quizdata);

    useEffect(() => {
        const allq = questions;
        setAllquestions(allq);
        setInitdata(allq.content);
        setQuizdata(allq.content);

        const imageUrls = allq.content
            .filter(item => item.isimage && Array.isArray(item.image))
            .flatMap(item => item.image.map(img => img.grid_img))
            .filter(url => url);

        let loadedImages = 0;
        const totalImages = imageUrls.length;

        if (totalImages === 0) {
            setImagesPreloaded(true);
            return;
        }

        const handleImageLoad = () => {
            loadedImages++;
            if (loadedImages === totalImages) {
                setImagesPreloaded(true);
            }
        };

        imageUrls.forEach(url => {
            const img = new Image();
            img.src = url;
            img.onload = handleImageLoad;
            img.onerror = handleImageLoad; // Count errors as loaded to not block the app
        });
    }, []);

    const Intro = () => {
        const [start, setStart] = useState(false);

        return (
            <div>
                {start ? (
                    <QuizComponent />
                ) : (
                    <div className='flex flex-col items-center justify-center min-h-[70vh]'>
                        <div className='w-80'>
                            <img src={require('./story-of-life-s2.png')} alt="Story of Life" />
                        </div>
                        <button
                            className='rotating-border-button'
                            onClick={() => setStart(true)}
                            disabled={!imagesPreloaded}
                        >
                            {imagesPreloaded ? (
                                <p className='text-center gradient-small'>
                                    Start Simulation
                                </p>
                            ) : (
                                <Spin size="small" />
                            )}
                        </button>
                    </div>
                )}
            </div>
        );
    };

    return (
        <>
            <Intro />
        </>
    );
};

export default StoryOfLife